import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Trash16 } from '@makyoapp/makyo-icon/icon'
import { Button, ButtonColor, DeleteModal } from '@makyoapp/makyo-ui'

import { toasted } from '@/lib/toast'

interface Props {
  onDelete(): Promise<number>
}

export function DeleteRowAction({ onDelete }: Props) {
  const { t } = useTranslation()

  const [isDelete, setIsDelete] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleDeleteSelection = async () => {
    setIsLoading(true)

    await onDelete()
      .then((deletedCount) => {
        if (deletedCount > 0) {
          toasted(t('{{count}} rows deleted', { count: deletedCount }))
        }
      })
      .finally(() => {
        setIsLoading(false)
        setIsDelete(false)
      })
  }

  return (
    <>
      <Button
        colorStyle={ButtonColor.Danger}
        onClick={() => {
          setIsDelete(true)
        }}
        noPadding
        className='w-9'
        title={t('Delete Selected Rows')}
      >
        <Trash16 />
      </Button>

      <DeleteModal
        show={isDelete}
        isLoading={isLoading}
        onHide={() => setIsDelete(false)}
        onSubmit={handleDeleteSelection}
        continueLabel={t('Yes, delete')}
        title={t('Delete Rows')}
      >
        <div className='text-sm min-w-[250px]'>
          <Trans>Are you sure you&apos;d like to delete all selected rows?</Trans>
        </div>
      </DeleteModal>
    </>
  )
}
